import { uniq } from "lodash";

import type { BookingsFilterQuery_viewer_bookings_byFilter } from "../graphql/gql/BookingsFilterQuery";
import type { BookingsFilterQueryResult } from "../gridReducer";

export const mergeBookingNos = (
  prevResult: BookingsFilterQueryResult | null,
  result: BookingsFilterQuery_viewer_bookings_byFilter,
): number[] =>
  uniq([
    ...(prevResult?.result?.bookingNos ?? []),
    ...result.bookings.map((b) => b.bookingNo),
  ]);
